// useEvenementsDirect.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import EvenementDirectService from "@/integrations/service/evenement-direct.service";

export const useEvenementsDirect = () => {
  return useQuery({
    queryKey: ["evenements-direct"],
    queryFn: EvenementDirectService.getAll,
    refetchInterval: 30_000,
  });
};

export const useEvenementDirect = (id: number) => {
  return useQuery({
    queryKey: ["evenement-direct", id],
    queryFn: () => EvenementDirectService.getById(id),
    enabled: !!id,
    refetchInterval: 30_000,
  });
};

export const useCreateEvenementDirect = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: EvenementDirectService.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["evenements-direct"] });
    },
  });
};

export const useCloseEvenementDirect = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: EvenementDirectService.close,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["evenements-direct"] });
    },
  });
};

export const useAddMiseAJourDirect = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: number;
      payload: any;
    }) => EvenementDirectService.addUpdate(id, payload),

    onSuccess: (_, variables) => {
      qc.invalidateQueries({ queryKey: ["evenements-direct"] });
      qc.invalidateQueries({
        queryKey: ["evenement-direct", variables.id],
      });
    },
  });
};